import { render, staticRenderFns } from "./RecoveredPenalties.vue?vue&type=template&id=0cc5c3dc"
import script from "./RecoveredPenalties.vue?vue&type=script&lang=js"
export * from "./RecoveredPenalties.vue?vue&type=script&lang=js"
import style0 from "./RecoveredPenalties.vue?vue&type=style&index=0&id=0cc5c3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports